import { render } from "./AdministratorOneUserContent.vue?vue&type=template&id=bc2ba4fa&scoped=true"
import script from "./AdministratorOneUserContent.vue?vue&type=script&lang=js"
export * from "./AdministratorOneUserContent.vue?vue&type=script&lang=js"

import "./AdministratorOneUserContent.vue?vue&type=style&index=0&id=bc2ba4fa&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2ba4fa"]])

export default __exports__